"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectDTOSchema = void 0;
const zod_1 = require("zod");
const ProjectDTOSchema = zod_1.z.object({
    content: zod_1.z.string(),
    price: zod_1.z.number(),
});
exports.ProjectDTOSchema = ProjectDTOSchema;
